import { FC } from 'react';

import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
} from '@/components/ui/Form';
import RadioGroup, { RadioItem } from '@/components/ui/RadioGroup';

import { useLingui } from '@lingui/react';
import { useFormContext } from 'react-hook-form';

export const ACCIDENT_REPORTED_TO_INSURER_VALUES = {
  YES_MY_INSURE: 'yes_my_insure',
  YES_PERPETRATOR: 'yes_perpetrator',
  NO: 'no',
} as const;

export const ACCIDENT_REPORTED_TO_INSURER_NAME = 'accident_reported_to_insurer';
export const ACCIDENT_REPORTED_TO_INSURER_NAME_COMPLEMENTARY =
  'accident_reported_to_insurer_complementary';

interface Props {
  name?: string;
  isComplementary?: boolean;
}

export const RadioGroupAccidentReportedToInsurer: FC<Props> = ({
  name,
  isComplementary = false,
}) => {
  const { i18n } = useLingui();
  const { control } = useFormContext();

  const fieldName =
    name ??
    (isComplementary
      ? ACCIDENT_REPORTED_TO_INSURER_NAME_COMPLEMENTARY
      : ACCIDENT_REPORTED_TO_INSURER_NAME);

  return (
    <FormField
      control={control}
      name={fieldName}
      rules={{
        required: {
          value: true,
          message: i18n.t('Uzupełnij to pole, aby przejść dalej'),
        },
      }}
      render={({ field }) => (
        <FormItem>
          <FormLabel>
            {i18n.t('Czy szkoda została zgłoszona do ubezpieczyciela?')}
          </FormLabel>
          <FormControl>
            <RadioGroup {...field}>
              <RadioItem
                value={ACCIDENT_REPORTED_TO_INSURER_VALUES.YES_MY_INSURE}
                label={i18n.t('Tak, do mojego ubezpieczyciela')}
                data-testid="radio-group-accident-reported-to-insurer-yes-my-insure"
              />
              <RadioItem
                value={ACCIDENT_REPORTED_TO_INSURER_VALUES.YES_PERPETRATOR}
                label={i18n.t('Tak, do ubezpieczyciela sprawcy')}
                data-testid="radio-group-accident-reported-to-insurer-yes-perpetrator"
              />
              {!isComplementary && (
                <RadioItem
                  value={ACCIDENT_REPORTED_TO_INSURER_VALUES.NO}
                  label={i18n.t('Nie, szkoda nie została zgłoszona')}
                  data-testid="radio-group-accident-reported-to-insurer-no"
                />
              )}
            </RadioGroup>
          </FormControl>
        </FormItem>
      )}
    />
  );
};
